import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import "core-js/modules/es6.array.filter.js";
import endUserMessages from 'utils/endUserMessages';
import { SAMPLES_BULK_KIT_UPDATE, SAMPLES_SAVING, SAMPLES_SAVED } from 'redux/actionTypes/samples';
import fetchAPI from 'utils/http/fetchAPI';
import { isParseSampleTech } from 'const/enums/SampleTech';
import { loadBackendStatus } from '../backendStatus';
var bulkUpdateSampleKits = function bulkUpdateSampleKits(sampleIds, kit) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var parseSampleIds, experimentId, url, body;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            parseSampleIds = sampleIds.filter(function (sampleId) {
              return isParseSampleTech(getState().samples[sampleId].type);
            });
            if (!(parseSampleIds.length === 0)) {
              _context.next = 3;
              break;
            }
            throw new Error('parse sampleIds array cannot be empty');
          case 3:
            // In api v2 experimentId and experimentId are the same
            experimentId = getState().samples[sampleIds[0]].experimentId;
            url = "/v2/experiments/".concat(experimentId, "/samples/kit");
            body = {
              sampleIds: parseSampleIds,
              kit: kit
            };
            dispatch({
              type: SAMPLES_SAVING,
              payload: {
                message: endUserMessages.SAVING_SAMPLE
              }
            });
            _context.next = 9;
            return fetchAPI(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(body)
            });
          case 9:
            dispatch({
              type: SAMPLES_SAVED
            });
            dispatch({
              type: SAMPLES_BULK_KIT_UPDATE,
              payload: {
                sampleIds: parseSampleIds,
                kit: kit
              }
            });
            _context.next = 13;
            return dispatch(loadBackendStatus(experimentId));
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default bulkUpdateSampleKits;